import { render, staticRenderFns } from "./rewardTreasureEdit.vue?vue&type=template&id=3f17c91c&scoped=true&"
import script from "./rewardTreasureEdit.vue?vue&type=script&lang=js&"
export * from "./rewardTreasureEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f17c91c",
  null
  
)

export default component.exports